import React, { useEffect, useState } from 'react';

export const DividerElementSettings = function FromElement({ element, handlerChangeOption }) {
  return (
    <div className="tabs-item">
      <div className="property-item">
        <h3 className="form-builder-aside-property-sub-title">Is visible on form?</h3>
        <div className="form-switcher">
          <input
            type="checkbox"
            name="isVisible"
            checked={!!element?.options?.isVisible}
            onChange={(e) => {
              handlerChangeOption(e.target.checked, 'isVisible', element.id);
            }}
          />
          <span>{element?.options?.isVisible ? 'Yes' : 'No'}</span>
        </div>
      </div>
    </div>
  );
};
